<template>
  <view-box
    v-if="$store.state.displayDetailView && $store.state.poi !== undefined"
    class="view-box viewboxvisible"
    :heading="$t('detailView.heading')"
    icon="mdi-format-list-bulleted"
  >
    <div
      class="container pa-1 pt-3 inviewbox"
      :style="$mq | mq({
        desktop:'width: 100%;'
      })"
    >
      <div class="content">
        <v-list-item>
          <v-list-item-avatar
            tile
          >
            <v-icon color="#0D0D0D">
              {{ $icons.getIconById($store.state.poi.category).icon }} mdi-36px
            </v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title class="headline text-wrap">
              {{ $store.state.poi.label }}
            </v-list-item-title>
            <v-list-item-subtitle class="text-wrap">
              {{ $store.state.poi.sublabel }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-simple-table
          v-if="$mq === 'desktop'"
          fixed-header
          width="100%"
        >
          <template v-slot:default>
            <tbody>
              <tr v-if="$mq === 'mobile'">
                <td>Zur Karte</td>
                <td class="flex">
                  <v-btn
                    class="ma-1"
                    :color="baseColor"
                    @click="$store.commit('hideSubMenus');$store.commit('closeSearchMenu');$store.commit('closeDetailView');"
                  >
                    <v-icon>
                      mdi-map-outline
                    </v-icon>
                  </v-btn>
                </td>
              </tr>
              <tr v-if="showCategoryTitle()">
                <td>{{ $t('various.category') }}</td>
                <td class="text-capitalize">
                  {{ $store.state.poi.category }}
                </td>
              </tr>
              <tr
                v-for="(cat, i) in searchableCategories"
                v-show="$store.state.poi.category === 'adressen'"
                :key="i+100"
              >
                <td>Nach {{ cat.id }} suchen</td>
                <td class="flex">
                  <v-btn
                    class="ma-1"
                    :color="baseColor"
                    @click="handleSolrRequest(cat.id)"
                  >
                    <v-icon>
                      mdi-magnify
                    </v-icon>
                  </v-btn>
                </td>
              </tr>
              <tr
                v-for="(value, name, i) in $store.state.poi.meta"
                :key="i"
              >
                <td
                  v-if="value !== null"
                >
                  {{ name }}
                </td>
                <td
                  v-if="value !== null && value.startsWith('http')"
                  class="flex"
                >
                  <v-btn
                    :href="value"
                    class="ma-1"
                    target="_blank"
                    link
                    :color="baseColor"
                  >
                    <v-icon>
                      mdi-earth
                    </v-icon>
                  </v-btn>
                </td>
                <td
                  v-else-if="value !== null && value.startsWith('mailto:')"
                  class="flex"
                >
                  <v-btn
                    :href="value"
                    class="ma-1"
                    target="_blank"
                    link
                    :color="baseColor"
                  >
                    <v-icon class="inline-icon">
                      mdi-email-outline
                    </v-icon>
                    <small>{{value.replace('mailto:','')}}</small>
                  </v-btn>
                </td>
                <td
                  v-else-if="value !== null && value.startsWith('tel:')"
                  class="flex"
                >
                  <v-btn
                    :href="value"
                    class="ma-1"
                    target="_blank"
                    link
                    :color="baseColor"
                  >
                    <v-icon class="inline-icon">
                      mdi-phone
                    </v-icon>
                    <small>{{value.replace('tel:','')}}</small>
                  </v-btn>
                </td>
                <td
                  v-else-if="value !== null && (value === 'true' || value === 'false')"
                >
                  <v-icon
                    v-if="isTrue(value)"
                    color="green"
                  >
                    mdi-check
                  </v-icon>
                  <v-icon
                    v-else
                    color="red"
                  >
                    mdi-close
                  </v-icon>
                </td>
                <td
                  v-else-if="name === 'Wikipedia'"
                  class="flex"
                >
                  <v-btn
                    :href="linkToWikipedia(value)"
                    class="ma-1"
                    target="_blank"
                    link
                    :color="baseColor"
                  >
                    <v-icon>
                      mdi-earth
                    </v-icon>
                  </v-btn>
                </td>
                <td
                  v-else-if="value !== null && value.startsWith('/')"
                  class="flex"
                >
                  <v-btn
                    :href="linkToDataDirectory(value)"
                    class="ma-1"
                    target="_blank"
                    link
                    :color="baseColor"
                  >
                    <v-icon>
                      mdi-earth
                    </v-icon>
                  </v-btn>
                </td>
                <td
                  v-else-if="value !== null"
                >
                  {{ value }}
                </td>
              </tr>
              <tr v-if="isGoogleMapsRouteEnabled()" class="flex">
                <td>
                  Navigation<br/>
                  <small>via Google Maps</small>
                </td><!--TODO-->
                <td>
                  <v-btn
                    :href="getRouteURL()"
                    class="ma-1"
                    target="_blank"
                    link
                    :color="baseColor"
                  >
                    <v-icon>
                      mdi-navigation
                    </v-icon>
                  </v-btn>
                </td>
              </tr> 
              <h4
                v-if="getCatContact()"
                style="margin:24px 0 0 16px"
              >
                {{ $t('various.moreInformation') }}
              </h4>
              <tr v-if="categoryContact && categoryContact.name !== undefined">
                <td> {{ $t('various.name') }}</td>
                <td>{{ categoryContact.name }}</td>
              </tr>
              <tr v-if="categoryContact && categoryContact.department !== undefined">
                <td> {{ $t('various.department') }}</td>
                <td>{{ categoryContact.department }}</td>
              </tr>
              <tr v-if="categoryContact && categoryContact.phone !== undefined">
                <td> {{ $t('various.phone') }}</td>
                <td>{{ categoryContact.phone }}</td>
              </tr>
              <tr v-if="categoryContact && categoryContact.email !== undefined">
                <td> {{ $t('various.email') }}</td>
                <td>{{ categoryContact.email }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <div v-else>
              <div v-if="$mq === 'mobile'" class="row-container">
                <div class="row-entry"><h4>Zur Karte</h4></div>
                <div class="row-entry">
                  <v-btn
                    class="ma-1"
                    :color="baseColor"
                    @click="$store.commit('hideSubMenus');$store.commit('closeSearchMenu');$store.commit('closeDetailView');"
                  >
                    <v-icon>
                      mdi-map-outline
                    </v-icon>
                  </v-btn>
                </div>
              </div>
              <v-divider v-if="$mq === 'mobile'"></v-divider>
              <div v-if="showCategoryTitle()" class="row-container">
                <div class="row-entry"><h4>{{ $t('various.category') }}</h4></div>
                <div class="row-entry text-capitalize">
                  {{ $store.state.poi.category }}
                </div>
              </div>
              <div
                v-for="(cat, i) in searchableCategories"
                v-show="$store.state.poi.category === 'adressen'"
                :key="i+100"
                class="row-container"
              >
                <v-divider v-if="showCategoryTitle()"></v-divider>
                <div class="row-entry">Nach {{ cat.id }} suchen</div>
                <div class="row-entry">
                  <v-btn
                    class="ma-1"
                    :color="baseColor"
                    @click="handleSolrRequest(cat.id)"
                  >
                    <v-icon>
                      mdi-magnify
                    </v-icon>
                  </v-btn>
                </div>
              </div>
              <div
                v-for="(value, name, i) in $store.state.poi.meta"
                :key="i"
                class="row-container"
              >
                <v-divider v-if="i != 0"></v-divider>
                <div
                  v-if="value !== null"
                  class="row-entry"
                >
                  <h4>{{ name }}</h4>
                </div>
                <div
                  v-if="value !== null && value.startsWith('http')"
                  class="row-entry"
                >
                  <v-btn
                    :href="value"
                    class="ma-1"
                    target="_blank"
                    link
                    :color="baseColor"
                  >
                    <v-icon>
                      mdi-earth
                    </v-icon>
                    <!-- <small class="ellipsis">{{value}}</small> -->
                  </v-btn>
                </div>
                <div
                  v-else-if="value !== null && value.startsWith('mailto:')"
                  class="row-entry"
                >
                  <v-btn
                    :href="value"
                    class="ma-1"
                    target="_blank"
                    link
                    :color="baseColor"
                  >
                    <v-icon class="inline-icon">
                      mdi-email-outline
                    </v-icon>
                    <small>{{value.replace('mailto:','')}}</small>
                  </v-btn>
                </div>
                <div
                  v-else-if="value !== null && value.startsWith('tel:')"
                  class="row-entry"
                >
                  <v-btn
                    :href="value"
                    class="ma-1"
                    target="_blank"
                    link
                    :color="baseColor"
                  >
                    <v-icon class="inline-icon">
                      mdi-phone
                    </v-icon>
                    <small>{{value.replace('tel:','')}}</small>
                  </v-btn>
                </div>
                <div
                  v-else-if="value !== null && (value === 'true' || value === 'false')"
                  class="row-entry"
                >
                  <v-icon
                    v-if="isTrue(value)"
                    color="green"
                  >
                    mdi-check
                  </v-icon>
                  <v-icon
                    v-else
                    color="red"
                  >
                    mdi-close
                  </v-icon>
                </div>
                <div
                  v-else-if="name === 'Wikipedia'"
                  class="row-entry"
                >
                  <v-btn
                    :href="linkToWikipedia(value)"
                    class="ma-1"
                    target="_blank"
                    link
                    :color="baseColor"
                  >
                    <v-icon>
                      mdi-earth
                    </v-icon>
                  </v-btn>
                </div>
                <div
                  v-else-if="value !== null && value.startsWith('/')"
                  class="row-entry"
                >
                  <v-btn
                    :href="linkToDataDirectory(value)"
                    class="ma-1"
                    target="_blank"
                    link
                    :color="baseColor"
                  >
                    <v-icon>
                      mdi-earth
                    </v-icon>
                  </v-btn>
                </div>
                <div
                  v-else-if="value !== null"
                  class="row-entry"
                >
                  {{ value }}
                </div>
              </div>
              <v-divider v-if="isGoogleMapsRouteEnabled()"></v-divider>
              <div v-if="isGoogleMapsRouteEnabled()" class="row-container">
                <div class="row-entry">
                  <h4>Navigation</h4><br/>
                  <small>via Google Maps</small>
                </div><!--TODO-->
                <div class="row-entry">
                  <v-btn
                    :href="getRouteURL()"
                    class="ma-1"
                    target="_blank"
                    link
                    :color="baseColor"
                  >
                    <v-icon>
                      mdi-navigation
                    </v-icon>
                  </v-btn>
                </div>
              </div>
              <v-divider v-if="getCatContact()"></v-divider>
              <h4
                v-if="getCatContact()"
                style="margin:24px 0 0 16px"
              >
                {{ $t('various.moreInformation') }}
              </h4>
              <div v-if="categoryContact && categoryContact.name !== undefined" class="row-entry">
                <div class="row-entry"><h4> {{ $t('various.name') }}</h4></div>
                <div class="row-entry"><h4>{{ categoryContact.name }}</h4></div>
              </div>
              <div v-if="categoryContact && categoryContact.department !== undefined" class="row-entry">
                <div class="row-entry"><h4>{{ $t('various.department') }}</h4></div>
                <div class="row-entry"><h4>{{ categoryContact.department }}</h4></div>
              </div>
              <div v-if="categoryContact && categoryContact.phone !== undefined" class="row-entry">
                <div class="row-entry"><h4>{{ $t('various.phone') }}</h4></div>
                <div class="row-entry"><h4>{{ categoryContact.phone }}</h4></div>
              </div>
              <div v-if="categoryContact && categoryContact.email !== undefined" class="row-entry">
                <div class="row-entry"><h4>{{ $t('various.email') }}</h4></div>
                <div class="row-entry"><h4>{{ categoryContact.email }}</h4></div>
              </div>
        </div>
      </div>
    </div>
  </view-box>
</template>

<script>

import ViewBox from '../ViewBox.vue';
import { EventBus } from '../../event-bus';

const displayed = false;

export default {
  name: 'DetailView',
  components: {
    ViewBox,
  },
  props: {
  },
  data() {
    return {
      search: '',
      select: '',
      displayed,
      baseColor: this.$appConfig.baseColor,
      baseColorAccent: this.$appConfig.baseColorAccent,
      mapCenter: this.$appConfig.mapCenter,
      categories: this.$appConfig.categories,
      categoryContact: undefined,
      categoryGoogleMapsEnabled: null,
      showCategoryTitleEnabled: null,
    };
  },
  computed: {
    searchableCategories() {
      return this.categories.filter((cat) => cat.searchable === true);
    },
  },
  methods: {
    handleSolrRequest(catToSearchFor) {
      if (this.$mq === 'mobile') {
        this.$store.commit('showSearchMenu');
      }
      EventBus.$emit('searchAtPoi', catToSearchFor, this.$store.state.poi);
    },
    capitalizeFLetter(s) {
      return `${s[0].toUpperCase()}${s.slice(1).toLowerCase()}`;
    },
    linkToDataDirectory(uri) {
      return `${this.$appConfig.dataDirectoryPath}${uri}`;
    },
    linkToWikipedia(wiki) {
      const lang = (wiki.split(':'))[0];
      const uri = (wiki.split(':'))[1];
      return `http://${lang}.wikipedia.org/wiki/${uri}`;
    },
    isTrue(string) {
      if (string === 'true') return true;
      return false;
    },
    getCategory() {
      return this.categories.find((e) => e.id === this.$store.state.poi.category);
    },
    getCatContact() {
      const x = this.getCategory();
      if (!x) {
        return null;
      }
      if (x.contact) {
        this.categoryContact = x.contact;
      } else {
        this.categoryContact = undefined; 
      }
      return this.categoryContact;
    },
    isGoogleMapsRouteEnabled() {
      const cat = this.getCategory();
      if (!cat) {
        this.categoryGoogleMapsEnabled = false;
        return this.categoryGoogleMapsEnabled;
      }
      if (cat.routeByGoogleMaps != null) {
        this.categoryGoogleMapsEnabled = cat.routeByGoogleMaps;
      } else {
        this.categoryGoogleMapsEnabled = false;
      }
      return this.categoryGoogleMapsEnabled;
    },
    showCategoryTitle() {
      const cat = this.getCategory();
      if (!cat) {
        this.showCategoryTitleEnabled = false;
        return this.showCategoryTitleEnabled;
      }
      if (cat.showCategoryTitleEnabled != null) {
        this.showCategoryTitleEnabled = cat.showCategoryTitle;
      } else {
        this.showCategoryTitleEnabled = false;
      }
      return this.showCategoryTitleEnabled;
    },
    getRouteURL() {
      const poi = this.$store.state.poi;
      const geom = poi["centerCoordinate"];
      return `https://www.google.com/maps/dir//${geom[1]},${geom[0]}/@${geom[1]},${geom[0]}`;
    },
  },
};

</script>

<style scoped>

  .container {
    background-color: transparent;
    visibility: visible;
    /* width: inherit; */
    height: auto;
  }
  .content {
    /* max-height: 95vh; */
    overflow-y: auto;
    width: 100%;
    padding-bottom: 80px;
  }

  .flex {
    display: flex;
  }

  .row-container {
    width: 100%;
  }
  .row-entry {
    width: 100%;
    margin: 8px 0;
    display: flex;
  }

  a {
    flex-grow: 1;
  }
  .inline-icon {
    margin-right: 4px;
  }

  .ellipsis {
    max-width: 80%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  @media (min-width: 1250px) {
    .viewboxvisible {
      visibility: visible;
    }
    .inviewbox {
      top: auto !important;
    }
  }
</style>
